/* eslint-disable no-param-reassign */
import {
  GET_REPORT_STOCKS_REQUEST,
  GET_REPORT_STOCKS_SUCCESS,
  GET_REPORT_STOCKS_FAILURE
} from "src/actions/reportStockActions";
import produce from "immer";

const initialState = {
  reportStocks: [],
  total: 0,
  loading: false
};

const reportStockReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_STOCKS_REQUEST: {
      return produce(state, (draft) => {
        draft.reportStocks = [];
        draft.loading = true;
      });
    }

    case GET_REPORT_STOCKS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.reportStocks = response;
        draft.total = total;
        draft.loading = false;
      });
    }

    case GET_REPORT_STOCKS_FAILURE: {
      return produce(state, (draft) => {
        draft.reportStocks = [];
        draft.loading = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default reportStockReducer;
